import { render, staticRenderFns } from "./VerticalNav.vue?vue&type=template&id=9e7bb2e4&scoped=true&"
import script from "./VerticalNav.vue?vue&type=script&lang=js&"
export * from "./VerticalNav.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNav.vue?vue&type=style&index=0&id=9e7bb2e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7bb2e4",
  null
  
)

export default component.exports